import {IBaseLookup} from "./Ibase.lookup";

export namespace Language {

    export const lookupName: string = "Language";

    export interface Language {
        languageKey: number;
        language: string;
        active: string;
        lastUpdated: Date;
        rightToLeft: string;
        olhFolder: string;
    }

    export interface LanguageTag {
        languageTagKey: number;
        languageKey: number;
        name: string;
        objectRef: string;
        text: string;
        active: string;
        lastUpdated: Date;
        description: string;
        translationRequirement: string;
        userid: string;
    }

    export interface LanguageDS extends IBaseLookup {
        language: Language[];
        languageTag: LanguageTag[];
    }
}
